/**************************************************
 * Nombre:       Dialogo_Hijo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Delete} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Usuario_Padres from "../Formularios/Formulario_Usuario_Padres";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {correoAId} from "../../CodNegocio/Funciones/correoAId";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";

const Dialogo_Hijo = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const [hijo, setHijo] = useState({})
    const [nivel, setNivel] = useState({})
    const [hijosNivel, setHijosNivel] = useState({})
    const [idCuenta, setIdCuenta] = useState({})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad();
        let padres = entidad.padres
        for (let i = 0; i < padres.length; i++) {
            let padre = padres[i]
            let doxEquipoPadre = await obtenerDoc('equipos', correoAId(padre))
            if (doxEquipoPadre.res) {

                await borrarHijo(hijo.idUsuario, nivel, hijosNivel, idCuenta)

                let equipoPadre = doxEquipoPadre.data;
                let nivelConseguir = equipoPadre[JSON.stringify(i)]
                console.log(nivelConseguir)
                let index = nivelConseguir.findIndex((e) => e.idUsuario === hijo.idUsuario)
                if (index === -1) {
                    let arr = nivelConseguir
                    arr.push(hijo)
                    await agrearHijoANivel(correoAId(padre), JSON.stringify(i), arr)
                }

            }
        }


        let arr = []
        for (let i = 0; i < padres.length; i++) {
            let padre = padres[i]
            arr.push(correoAId(padre))
        }
        entidad.padres = arr

        await guardarDoc('cuentas', entidad)


    }

    const borrarHijo = async (idHijo, nivel, hijosNivel, idCuenta) => {

        let arr = hijosNivel
        let index = hijosNivel.findIndex((e) => e.idUsuario === idHijo)
        if (index > -1) {
            arr.splice(index, 1)
        }

        //actualizar Equipo de idCuenta segun el nivel
        await actualizarDoc('equipos', idCuenta, {[nivel]: arr})


    }

    const agrearHijoANivel = async (idPadre, nivel, arr) => {

        await actualizarDoc('equipos', idPadre, {[nivel]: arr})

    }

    const borrar = async () => {

        await borrarHijo(hijo.idUsuario, nivel, hijosNivel, idCuenta)

    }
    useEffect(() => {

        if (datos.hijo && datos.hijo.idUsuario) {
            setHijo(datos.hijo)
            setNivel(datos.nivel)
            setHijosNivel(datos.hijosNivel)
            setIdCuenta(datos.idCuenta)
            obtenerDoc('cuentas', datos.hijo.idUsuario).then((dox) => {
                if (dox.res) {
                    setEntidad(dox.data);
                }
            })
        }


    }, [datos]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Usuario_Padres props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Editar</Button>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Button
                    onClick={() => borrar()}
                    color={'success'} startIcon={<Delete/>} variant={'text'}>
                    Borrar
                </Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Hijo